export default __webpack_public_path__ + "static/media/9.77f29310.svg";